/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'api/axios'
import { useCallback, useEffect, useState } from 'react'

const useFetchCamposExpediente = ({ expediente }) => {
  const [response, setResponse] = useState()
  const [error, setError] = useState()
  const [loading, setLoading] = useState()
  const [refetch, setRefetch] = useState(false)

  const fetchData = useCallback(() => {
    if (loading || !expediente) return
    setLoading(true)

    axios
      .post(`/expedienteslisa/getCamposExpediente/`, { expediente })
      .then((request_response) => {
        setResponse(request_response.data)
        setError(null)
      })
      .catch((request_error) => setError(request_error))
      .finally(() => setLoading(false))
  }, [expediente])

  useEffect(() => {
    if (!loading) fetchData()
  }, [fetchData, expediente, refetch])

  return { response, error, loading, refetch: () => setRefetch((prev) => !prev) }
}

export default useFetchCamposExpediente
